import { render, staticRenderFns } from "./QuizSimple.vue?vue&type=template&id=151290cc&"
import script from "./QuizSimple.vue?vue&type=script&lang=js&"
export * from "./QuizSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports